import { BrowserRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import '@/localization/config';
import Toast from '@/components/toast';
import Routes from '@/routes';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-datepicker/dist/react-datepicker.css';
import '@/scss/main.scss';
import { LoaderProvider } from '@/context/loaderContext';
import { FirebaseProvider } from './utils/firebase/context';

function App(): JSX.Element {
  return (
    <FirebaseProvider>
      <div>
        <LoaderProvider>
          <Helmet>
            <meta charSet="utf-8" />
            <title>ABC Admin Application</title>
          </Helmet>
          {/* We use BrowserRouter specifically because Router is on a higher-level and it will implicitly use one the implementations of Router by default anyway */}
          <BrowserRouter>
            <Routes />
          </BrowserRouter>
          <Toast />
        </LoaderProvider>
      </div>
    </FirebaseProvider>
  );
}

export default App;
